// extracted by mini-css-extract-plugin
export var modalFooter = "_ou-0";